var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (Array, continueBtnText, dirs, doneText, game, grid, hasNarration, hasPrompt, i18n, prompt, size, submitUp, title, undefined, words) {
if ( game && game.timer && game.timer.limit > 0 && !game.timer.isDisabled)
{
buf.push("<div class=\"full-screen\"><div class=\"game-stepper text-lg text-bold\"></div><div class=\"game-progress\"><div class=\"game-progress-bar\"></div></div></div>");
}
buf.push("<div class=\"content content-fit clearfix\"><div class=\"text-center block-v-lg\"><h1 class=\"fade-in\">" + (null == (jade_interp = title) ? "" : jade_interp) + "</h1><div class=\"grid-container block-md block-dk\"><div class=\"grid\">");
size = 1 / grid.length * 100;
dirs = ["up", "down", "left", "right"]
// iterate grid
;(function(){
  var $$obj = grid;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var row = $$obj[$index];

buf.push("<div" + (jade.attr("style", "height: " + (size) + "%;", true, false)) + " class=\"grid-row clearfix\">");
// iterate row
;(function(){
  var $$obj = row;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var col = $$obj[$index];

buf.push("<div" + (jade.attr("data-letter", col, true, false)) + (jade.attr("style", "width: " + (size) + "%;", true, false)) + (jade.cls(['grid-col','text-uppercase',"delay-" + (_.random(3)) + " slide-" + (_.sample(dirs)) + ""], [null,null,true])) + ">" + (jade.escape(null == (jade_interp = col) ? "" : jade_interp)) + "</div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var col = $$obj[$index];

buf.push("<div" + (jade.attr("data-letter", col, true, false)) + (jade.attr("style", "width: " + (size) + "%;", true, false)) + (jade.cls(['grid-col','text-uppercase',"delay-" + (_.random(3)) + " slide-" + (_.sample(dirs)) + ""], [null,null,true])) + ">" + (jade.escape(null == (jade_interp = col) ? "" : jade_interp)) + "</div>");
    }

  }
}).call(this);

buf.push("</div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var row = $$obj[$index];

buf.push("<div" + (jade.attr("style", "height: " + (size) + "%;", true, false)) + " class=\"grid-row clearfix\">");
// iterate row
;(function(){
  var $$obj = row;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var col = $$obj[$index];

buf.push("<div" + (jade.attr("data-letter", col, true, false)) + (jade.attr("style", "width: " + (size) + "%;", true, false)) + (jade.cls(['grid-col','text-uppercase',"delay-" + (_.random(3)) + " slide-" + (_.sample(dirs)) + ""], [null,null,true])) + ">" + (jade.escape(null == (jade_interp = col) ? "" : jade_interp)) + "</div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var col = $$obj[$index];

buf.push("<div" + (jade.attr("data-letter", col, true, false)) + (jade.attr("style", "width: " + (size) + "%;", true, false)) + (jade.cls(['grid-col','text-uppercase',"delay-" + (_.random(3)) + " slide-" + (_.sample(dirs)) + ""], [null,null,true])) + ">" + (jade.escape(null == (jade_interp = col) ? "" : jade_interp)) + "</div>");
    }

  }
}).call(this);

buf.push("</div>");
    }

  }
}).call(this);

buf.push("<div class=\"grid-highlights\">");
// iterate (new Array(words.length + 1))
;(function(){
  var $$obj = (new Array(words.length + 1));
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var word = $$obj[i];

buf.push("<div" + (jade.attr("style", "width: " + (size) + "%; height: " + (size) + "%;", true, false)) + (jade.cls(['grid-highlight',"grid-highlight-" + (i) + ""], [null,true])) + "></div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var word = $$obj[i];

buf.push("<div" + (jade.attr("style", "width: " + (size) + "%; height: " + (size) + "%;", true, false)) + (jade.cls(['grid-highlight',"grid-highlight-" + (i) + ""], [null,true])) + "></div>");
    }

  }
}).call(this);

buf.push("</div></div></div></div></div><div" + (jade.cls(['slide-footer','block-v-lg',submitUp ? "slide-footer--up slide-down" : "slide-up"], [null,null,true])) + ">");
if ( hasPrompt)
{
buf.push("<div class=\"slide-footer-touched\"><div class=\"btn btn-muted btn-done text-ellipsis\">" + (null == (jade_interp = doneText) ? "" : jade_interp) + "</div></div>");
if ( typeof prompt === "string")
{
buf.push("<div class=\"slide-footer-prompt text-uppercase text-bold\"><div class=\"slide-footer-prompt-content content-ver\">" + (null == (jade_interp = prompt) ? "" : jade_interp) + "</div></div>");
}
}
else
{
buf.push("<div class=\"slide-footer-prompt\"><div class=\"btn btn-muted btn-done text-ellipsis content-ver\">" + (null == (jade_interp = continueBtnText || i18n("buttons.continue")) ? "" : jade_interp) + "</div></div>");
}
if ( hasNarration)
{
buf.push("<div class=\"slide-footer-narration\"><div class=\"narration-progress btn btn-muted\"><div class=\"narration-progress-bar\"></div><div class=\"wave-ellipse\"><span class=\"bullet delay-1 block-inline\">&bullet;</span><span class=\"bullet delay-2 block-inline\">&bullet;</span><span class=\"bullet delay-3 block-inline\">&bullet;</span></div></div></div>");
}
buf.push("</div>");}.call(this,"Array" in locals_for_with?locals_for_with.Array:typeof Array!=="undefined"?Array:undefined,"continueBtnText" in locals_for_with?locals_for_with.continueBtnText:typeof continueBtnText!=="undefined"?continueBtnText:undefined,"dirs" in locals_for_with?locals_for_with.dirs:typeof dirs!=="undefined"?dirs:undefined,"doneText" in locals_for_with?locals_for_with.doneText:typeof doneText!=="undefined"?doneText:undefined,"game" in locals_for_with?locals_for_with.game:typeof game!=="undefined"?game:undefined,"grid" in locals_for_with?locals_for_with.grid:typeof grid!=="undefined"?grid:undefined,"hasNarration" in locals_for_with?locals_for_with.hasNarration:typeof hasNarration!=="undefined"?hasNarration:undefined,"hasPrompt" in locals_for_with?locals_for_with.hasPrompt:typeof hasPrompt!=="undefined"?hasPrompt:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"prompt" in locals_for_with?locals_for_with.prompt:typeof prompt!=="undefined"?prompt:undefined,"size" in locals_for_with?locals_for_with.size:typeof size!=="undefined"?size:undefined,"submitUp" in locals_for_with?locals_for_with.submitUp:typeof submitUp!=="undefined"?submitUp:undefined,"title" in locals_for_with?locals_for_with.title:typeof title!=="undefined"?title:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined,"words" in locals_for_with?locals_for_with.words:typeof words!=="undefined"?words:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}